module.exports = __webpack_public_path__ + "e0b9d74123ec6f84ebfbf19da80fbb7a.svg";